import { useState } from 'react';

import { VIEW_DATE_FORMAT } from 'utils/constants/date';
import { formatDate } from 'utils/date';

import Button, { ButtonIconPosition, ButtonKind, ButtonScale } from 'bloko/blocks/button';
import Checkbox from 'bloko/blocks/checkbox';
import Column from 'bloko/blocks/column';
import CustomSelect, { CustomSelectOption, CustomSelectOptionSecondaryText } from 'bloko/blocks/customSelect';
import { FormItem, FormLegend } from 'bloko/blocks/form';
import Icon, { IconAppearance, IconColor, IconKind, IconScale, IconView } from 'bloko/blocks/icon';
import VSpacing from 'bloko/blocks/vSpacing';

import useTrls from 'hooks/translation/useTrls';

import savePayer from 'components/Admin/PayerDetail/EditPayer/savePayer';

import { useDispatch, useSelector } from 'store/utils';

import 'components/Admin/PayerDetail/EditPayer/EditPayer.less';

const EditPayer = () => {
    const {
        hhPayerId,
        payers,
        agreement: { number },
        activePayer,
    } = useSelector((state) => state.payerDetail.payer);

    const dispatch = useDispatch();

    const getPayerId = (hhUserId, agreementId) => (hhUserId && agreementId ? `${hhUserId}-${agreementId}` : '');

    const [currentHhPayerId, setCurrentHhPayerId] = useState(getPayerId(hhPayerId, number));
    const [currentActivePayer, setCurrentActivePayer] = useState(activePayer);

    const trl = useTrls();

    return (
        <>
            <Column xs="4" s="8" m="6" l="8" container>
                <Column xs="4" s="8" m="3" l="3">
                    <FormLegend>{trl('admin.PayerDetail.Edit.select.hhPayerId.label')}</FormLegend>
                    <VSpacing base={2} />
                </Column>
                <Column xs="4" s="8" m="3" l="5">
                    <CustomSelect
                        value={currentHhPayerId}
                        onChange={(value) => setCurrentHhPayerId(value)}
                        emptyPlaceholder={trl('admin.PayerDetail.Edit.select.hhPayerId.placeholder')}
                    >
                        {payers.map(({ hhPayerId, hhPayerName, agreementId, agreementStartDate }) => {
                            const payerId = getPayerId(hhPayerId, agreementId);
                            return (
                                <CustomSelectOption key={payerId} value={payerId}>
                                    {`${hhPayerName} (${hhPayerId})`}
                                    <CustomSelectOptionSecondaryText>
                                        {`${trl('admin.Payers.Payer.agreement')} №${agreementId} от ${formatDate(
                                            agreementStartDate,
                                            VIEW_DATE_FORMAT
                                        )}`}
                                    </CustomSelectOptionSecondaryText>
                                </CustomSelectOption>
                            );
                        })}
                    </CustomSelect>
                    <VSpacing base={2} />
                </Column>
            </Column>
            <Column xs="4" s="8" m="6" l="8" container>
                <Column xs="4" s="8" m="3" l="3" />
                <Column xs="4" s="8" m="3" l="5">
                    <FormItem baseline={true}>
                        <Checkbox
                            value={currentActivePayer}
                            checked={currentActivePayer}
                            onChange={() => setCurrentActivePayer(!currentActivePayer)}
                        >
                            {trl('admin.PayerDetail.Edit.select.activePayer.label')}
                        </Checkbox>
                    </FormItem>
                    <VSpacing base={2} />
                </Column>
            </Column>
            <div className="edit-detail-button">
                <Button
                    scale={ButtonScale.Large}
                    kind={ButtonKind.Success}
                    icon={
                        <Icon
                            view={IconView.Checkmark}
                            initial={IconColor.White}
                            kind={IconKind.Single}
                            appearance={IconAppearance.Outlined}
                            scale={IconScale.Medium}
                        />
                    }
                    iconPosition={ButtonIconPosition.Left}
                    onClick={() => dispatch(savePayer(currentHhPayerId, currentActivePayer))}
                    disabled={!currentHhPayerId}
                >
                    {trl('admin.PayerDetail.Edit.save')}
                </Button>
                <VSpacing base={2} />
            </div>
        </>
    );
};

export default EditPayer;
